module.exports = __webpack_public_path__ + "static/media/MartriceCaldwell.ed1f3f18.jpg";